import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { PlatformHelper } from 'src/app/core/helpers/platform.helper';
import { Channel } from 'src/app/core/models/content-block.model';
import { ILink } from 'src/app/core/models/site.response';

import { LinkDirective } from '../../directives/link.directive';

@Component({
  selector: 'air-link-list',
  templateUrl: './link-list.component.html',
  imports: [NgTemplateOutlet, NgClass, RouterLinkActive, LinkDirective]
})
export class LinkListComponent implements OnInit {
  private element = inject(ElementRef);

  private _linkLists: ILink[] = [];
  @Input() get linkLists(): ILink[] {
    return this._linkLists;
  }
  set linkLists(value: ILink[]) {
    const channel = PlatformHelper.isNativeMobile ? Channel.app : Channel.web;
    this._linkLists = value?.filter((x) => !x.channels?.length || x.channels.includes(channel)) || [];
  }
  @Input() userEventSource: string;

  @ViewChild('pageLinks') pageLinksRef: TemplateRef<ElementRef>;

  isNavigation = false;

  ngOnInit(): void {
    if (this.element.nativeElement.closest('.nav')) {
      this.isNavigation = true;
    }
  }

  onSectionClick(event: Event): void {
    event.stopPropagation();
    const target = (event.currentTarget || event.target) as Element;
    target.classList.toggle('section--open');
    target.setAttribute('aria-expanded', target.classList.contains('section--open').toString());
  }

  onSectionFocusOut(event: FocusEvent): void {
    const target = (event.currentTarget || event.target) as Element;
    const section = target.closest('.link-list__section');
    if (section && !section.contains(event.relatedTarget as Node)) {
      section.classList.remove('section--open');
      target.setAttribute('aria-expanded', 'false');
    }
  }
}
